export default "__VITE_ASSET__H3AyOcez__"